import { useDidUpdate } from '@mantine/hooks';
import type { Logger } from 'loglevel';
import { getLogger, default as logger } from 'loglevel';
import { useEffect, useMemo } from 'react';

export type LoggerOptions = {
	log?: Logger | string;
	name: string;
	props: unknown[];
};

export function useLogger(options: LoggerOptions) {
	const log = useMemo(
		() =>
			!options.log
				? logger
				: typeof options.log === 'string'
					? getLogger(options.log)
					: options.log,
		[options.log],
	);

	useEffect(() => {
		log.debug(`${options.name} mounted`, ...options.props);
		return () => log.debug(`${options.name} unmounted`);
	}, [options.name, options.props, log]);

	useDidUpdate(() => {
		log.debug(`${options.name} updated`, ...options.props);
	}, [log, ...options.props]);

	return null;
}
